<script>
	import BarraCaracteristicas from './../components/BarraCaracteristicas.svelte';    

	import { Router, Link, link, Route } from "svelte-routing";
	import { beforeUpdate, afterUpdate } from 'svelte';

	export let realty = {Description:''};
	export let loading = false;

	let description = realty.Description.length > 100 ? realty.Description.substring(0, 100) : realty.Description;

	function replaceAll(str, de, para){
		if (typeof(str) == 'undefined') {
			return '';
		}
		
		let pos = str.indexOf(de);
		while (pos > -1){
			str = str.replace(de, para);
			pos = str.indexOf(de);
		}
		return str;
	}
	function getDetailURL() {
		let url = '/imovel/' + realty.CurrentNegotiationTypeTitle + '/' + realty.Id + '/imovel-';

		url = url + replaceAll(realty.CurrentRealtyTypeTitle, '/', '-');
		if (realty.CurrentSpot != null) {
			if (realty.CurrentSpot.Neighborhood != null && realty.CurrentSpot.Neighborhood != '') {
				url	= url + '-em-' + realty.CurrentSpot.Neighborhood;
			}

			if (realty.CurrentSpot.City != null && realty.CurrentSpot.City != '') {
				url	= url + '-' + realty.CurrentSpot.City;
			}
		}

		if (realty.MLSID != null && realty.MLSID != '') {
			url	= url + '-Cod-' + realty.MLSID;
		}

		return url.replaceAll(' ', '-');
	}

	let url = getDetailURL();

	//Carrega bookmarks
	atria.loadBookmarks();
	
	let favoritar = { 
		favorito: atria.hasBookmark(realty.CurrentNegotiationTypeId, realty.Id) 
	};

	function toggleBookmarks() {
		if (atria.hasBookmark(realty.CurrentNegotiationTypeId, realty.Id)) {
			atria.removeBookmark(realty.CurrentNegotiationTypeId, realty.Id);
		} else {
			atria.addBookmark(realty.CurrentNegotiationTypeId, realty.Id);
		}

		favoritar.favorito = !favoritar.favorito;
	}

	async function loadPhotos() 
	{
		let url = `${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=realty&callback=null&`;
		url += Object.entries({nt:realty.CurrentNegotiationTypeId, ri:realty.Id}).map(e=>`${e[0]}=${e[1]}`).join('&');
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});
		let data = await response.json()

		if (!data.Error && data.Items.length == 1) {
			images = [... data.Items[0].Photos];
			hasLoadPhotos = true;
		}
	}
	async function nextPhoto() {
		jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick('next');
	}
	async function prevPhoto() {
		jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick('prev');
	}

	$: hasLoadPhotos = false;
	$: images = realty.Image != null && realty.Image.length > 0 ? [{Title:realty.Title,Path:realty.Image}] : [];

	afterUpdate(() => {
		if (jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).length > 0) {

			jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick({
				infinite: true,
				speed: 400,
				slidesToShow: 1,
				autoplay: true,
				arrows: false,
				dots: false
			});
			jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick('next');
		}
	});

	//loadPhotos();
</script>

{#if loading}
	<div class="card loading">
		<div class="card-image">
			<figure class="image">
				<span class="loading-img" style="height: 200px;"></span>
			</figure>
		</div>
		<div class="card-content">
			<p class="title is-4"><span class="loading-text" style="max-width:150px;height:35px;"></span></p>
			<p class="subtitle is-6"><span class="loading-text" style="height:28px;"></span></p>
			<div class="content"><span class="loading-text" style="height:28px;"></span></div>
		</div>
	</div>
{:else}
	<div class="card card--{realty.CurrentNegotiationTypeTitle} card--realty-{realty.Id}">
		<div class="card-image">
			<a href="{url}" use:link replace target="_self">
				{#if images.length <= 1}
				<figure class="image loading-img">
					<img onerror="ImageNotFound(this);" src="{realty.Image}" alt="{realty.Title}">
				</figure>
				<button class:hide={hasLoadPhotos} onclick="return false;" on:click={loadPhotos} type="button" class="slick-next slick-arrow" aria-label="Ver fotos">Ver fotos</button>
				{:else}
				<div class="carousel slide" data-interval="false" data-wrap="false">
					<div class="carousel-inner" role="listbox">
						{#each images as image, i}
						<div class="item">
							<figure class="image loading-img">
								<img onerror="ImageNotFound(this);" src="{image.Path}" alt="{image.Title}">
							</figure>
						</div>
						{/each}
					</div>
				</div>
				<button onclick="return false;" on:click={nextPhoto} type="button" class="slick-next slick-arrow" aria-label="Próxima">Próxima</button>
				<button onclick="return false;" on:click={prevPhoto} type="button" class="slick-prev slick-arrow" aria-label="Anterior">Anterior</button>
				{/if}
				<div class="favoritar">
					{#if favoritar.favorito}
						<a href="javascript:void(0)" class="favorito icon-transform" onclick="return false;" on:click={toggleBookmarks}><i class="fas fa-heart"></i></a>
					{:else }
						<a href="javascript:void(0)" class="favorito icon-transform" onclick="return false;" on:click={toggleBookmarks}><i class="far fa-heart"></i></a>
					{/if}                    
				</div>
				<div class="code">
					<i class="fas fa-hashtag"></i> {realty.ReferenceId}
				</div>
			</a>
		</div>
		<div class="card-content">
			<h3 class="item">
				<b>{realty.CurrentRealtyTypeTitle}</b>
			</h3>
			<div class="item">
				<address>
					<p>{realty.CurrentSpot.Neighborhood}, {realty.CurrentSpot.City}</p>                        
				</address>
			</div>
			<div class="item mt-20 hide">
				<BarraCaracteristicas style="list" realty={realty}/>            
			</div>
			<div class="price mt-20">
				{#if realty.ShowPrice}
					<p class="btn text-nowrap">R$ {realty.FormattedPrice}</p>
				{:else}
					<p class="btn">Consulte</p>
				{/if}
			</div>
		</div>
	</div>
{/if}
<style type="text/sass">

@import 'public/assets/sass/variables.sass'

.card.loading
	.card-image
		.img
			width: 100%
			height: 200px
			background-color: #999
.card .slick-next
	right: 10px
.card .slick-prev
	left: 10px
// Paginação 
.page-item.active .page-link
	background-color: $color-secondary
	border-color: $color-secondary    

</style>